import React, { createContext, useState } from 'react'

export const AuctionContext = createContext()

export const AuctionProvider = (props) => {
  const [auction, setAuction] = useState({})
  const [readed, setReaded] = useState(0)
  const [readedMessages, setReadedMessages] = useState(0)
  return (
    <AuctionContext.Provider
      value={{
        auction,
        setAuction,
        readed,
        setReaded,
        readedMessages,
        setReadedMessages,
      }}
    >
      {props.children}
    </AuctionContext.Provider>
  )
}
